import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon as DesignSystemIcon } from 'pcln-design-system';
import { space, color } from 'styled-system';
import icons from '../../../icons.json';

// eslint-disable-next-line react/prop-types
const Base = ({ name, size, ...props }) => {
    const icon = icons[name];

    return icon ? (
        <svg viewBox={icon.viewBox} width={size} height={size} fill="currentColor" {...props}>
            <path d={icon.path} />
        </svg>
    ) : (
        <DesignSystemIcon name={name} size={size} {...props} />
    );
};
const Icon = styled(Base)`
    flex: none;
    ${space} ${color};
`;
Icon.displayName = 'Icon';
Icon.defaultProps = {
    name: 'checkLight',
    size: 24
};
Icon.propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

/**
 * @component
 */
export default Icon;
